import React from 'react';
import { compose, pure } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import BatchShopConfirmDialog from '../molecules/BatchShopConfirmDialog';

const styles = {
  button: {
    margin: '5px 5px'
  }
};

const enhance = compose(pure);

const button = enhance(
  ({
    classes,
    openConfirm,
    updateOpenConfirm,
    onClickAction,
    name,
    validateData,
    disabled,
    registerAction
  }) => {
    const cancelAction = () => {
      updateOpenConfirm(false);
    };
    return (
      <>
        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          onClick={onClickAction}
          disabled={disabled}
        >
          {name}
        </Button>
        <BatchShopConfirmDialog
          openConfirm={openConfirm}
          updateOpenConfirm={updateOpenConfirm}
          cancelAction={cancelAction}
          confirmAction={registerAction}
          target=""
          validateData={validateData}
        />
      </>
    );
  }
);

export default withStyles(styles)(button);
